import AuthService from '../../services/AuthService';

const Auth = new AuthService();
export function getEntrepriseInfos(){
    return {
        type:"GET_ENTREPRISE_INFO",
        payload: Auth.fetch("/societe/infos")
    }
}

export function setEntrepriseInfos(infos){
    return {
        type:"SET_ENTREPRISE_INFO",
        payload:infos
    }
}

export function getEntrepriseSalaries(){
    return {
        type:"GET_ENTREPRISE_SALARIES",
        payload: Auth.fetch("/societe/salaries")
    }
}

export function generateRandomLogoToken(){
    return {
        type:"GENERATE_RANDOM_LOGO_TOKEN",
        payload: Math.random()
    }
}

export function getPerspectives(){
    return {
        type:"GET_PERSPECTIVES",
        payload: Auth.fetch("/societe/perspectives")
    }
}


// WEBPACK FOOTER //
// ./src/actions/entreprise/actions_entreprise_1.js